import { render, staticRenderFns } from "./PageItem.vue?vue&type=template&id=b70016c4&scoped=true"
import script from "./PageItem.vue?vue&type=script&lang=js"
export * from "./PageItem.vue?vue&type=script&lang=js"
import style0 from "./PageItem.vue?vue&type=style&index=0&id=b70016c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70016c4",
  null
  
)

export default component.exports